export const RM_CONTACTS = {
    CSU: { name: null, email: 'support.ae@edenred.com', phNumber: ' +971 4 521 4062 ' },
    Mukesh: { name: ' Mukesh Prince ', email: ' Mukesh.PRINCE@edenred.com ', phNumber: ' +971 56 508 6116 ' },
    Bahaa: { name: ' Bahaa Assouma ', email: ' bahaa.assouma@edenred.com ', phNumber: ' +971 54 448 3470 ' },
    Shagufta: { name: ' Shagufta Hina ', email: ' shagufta.hina@edenred.com ', phNumber: ' +971 56 424 5188 ' },
    'Sana Khan': { name: ' Sana Khan ', email: ' sana.khan@edenred.com ', phNumber: ' +971 50 447 0628 ' },
    Jobin: { name: ' Jobin Ryan ', email: ' Jobin.RYAN@edenred.com ', phNumber: ' +971 52 742 5148 ' },
    'Reshma Prasad': { name: ' Reshma Prasad ', email: ' Reshma.PRASAD@edenred.com ', phNumber: ' +971 50 427 5370 ' }
};

export const DEFAULT_RM = RM_CONTACTS.CSU;